// src/reducers/intro_vids_reducer.js
import {
  INTRO_VIDS_REQUEST,
  INTRO_VIDS_SUCCESS,
  INTRO_VIDS_ERROR,
  INTRO_VIDS_CLEAR_ERRORS,
} from '../actions/intro_vids_actions';

const initialState = {
  items: [],
  loading: false,
  error: null,
  lastFetchedAt: null,
};

export default function introVidsReducer(state = initialState, action) {
  switch (action.type) {
    case INTRO_VIDS_REQUEST:
      return { ...state, loading: true, error: null };
    case INTRO_VIDS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: Array.isArray(action.payload) ? action.payload : [],
        lastFetchedAt: Date.now(),
      };
    case INTRO_VIDS_ERROR:
      return { ...state, loading: false, error: action.error };
    case INTRO_VIDS_CLEAR_ERRORS:
      return { ...state, error: null };
    default:
      return state;
  }
}
